<template>
  <el-row class="el-title">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <el-row class="list-shop__header top-spacing">
      <el-col v-loading="loadingData" :sm="24">
        <div class="transfer-container">
          <div class="qr-img">
            <!-- <div ref="qrCode"></div> -->
            <img ref="qrImage" :src="transferData.qr_image" />
            <p style="color: #e31d1d;" class="fw-600 c-body2">
              {{ $t("wap.text76") }}
            </p>
          </div>
          <div class="info-transfer">
            <div class="info-transfer-item">
              <div class="account-info">
                <div>
                  <div style="margin: 0;">
                    <label style="margin: 0;">{{ $t("wap.text77") }}:</label>
                  </div>
                  <span>{{ transferData.bank_id }}</span>
                </div>
                <button
                  class="copy-btn"
                  @click="copyToClipboard(transferData.bank_id)"
                >
                  <img class="mr-5" :src="icons.IconCopy" alt="" />
                </button>
              </div>
            </div>
            <div class="info-transfer-item">
              <div class="account-info">
                <div>
                  <div>
                    <label style="margin: 0;">{{ $t("wap.text78") }}:</label>
                  </div>
                  <span>{{ transferData.bank_account }}</span>
                </div>
                <button
                  class="copy-btn"
                  @click="copyToClipboard(transferData.bank_account)"
                >
                  <img class="mr-5" :src="icons.IconCopy" alt="" />
                </button>
              </div>
            </div>
            <div class="info-transfer-item">
              <div class="account-info">
                <div>
                  <div>
                    <label style="margin: 0;">{{ $t("wap.text79") }}:</label>
                  </div>
                  <span>{{ transferData.bank_name }}</span>
                </div>
                <button
                  class="copy-btn"
                  @click="copyToClipboard(transferData.bank_name)"
                >
                  <img class="mr-5" :src="icons.IconCopy" alt="" />
                </button>
              </div>
            </div>
            <div class="info-transfer-item">
              <div class="account-info">
                <div>
                  <div>
                    <label style="margin: 0;">{{ $t("wap.text80") }}:</label>
                  </div>
                  <span>{{ moneyPaid | formatCurrency }}</span>
                </div>
                <button
                  class="copy-btn"
                  @click="copyToClipboard(transferData.amount)"
                >
                  <img class="mr-5" :src="icons.IconCopy" alt="" />
                </button>
              </div>
            </div>

            <div class="info-transfer-item">
              <div class="account-info">
                <div>
                  <label style="margin: 0;">{{ $t("wap.text81") }}:</label>
                  <span>{{ transferData.bank_code }}</span>
                </div>
                <button
                  class="copy-btn"
                  @click="copyToClipboard(transferData.bank_code)"
                >
                  <img class="mr-5" :src="icons.IconCopy" alt="" />
                </button>
              </div>
            </div>
            <div>
              <span style="color: #e31d1d;" class="c-tiny fw-500">{{
                $t("wap.text82")
              }}</span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-row>
</template>
<script>
import { Message } from "element-ui";
import IconCopy from "@/assets/img/svg/copy.svg";
import GlobalAPI from "@/views/api/wap/global";
import { getDepositAmount } from "@/utils/booked";
import MainNavBarWapV2 from "@/layout/WapV2/MainNavBar.vue";

export default {
  components: {
    MainNavBarWapV2
  },
  props: {},
  filters: {
    formatCurrency(value) {
      return new Intl.NumberFormat("vi-VN", {
        style: "decimal",
        currency: "VND"
      }).format(value);
    }
  },
  data() {
    return {
      icons: {
        IconCopy
      },
      infoHeader: {
        title: this.$t("wap.text122"),
        isShowHomeIcon: true
      },
      moneyPaid: this.$route.params.payment_amount || getDepositAmount(),
      loadingData: false,
      transferData: {},
      dataPayment: {}
    };
  },
  created() {
    this.getDataPayment();
  },
  watch: {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    getDataPayment() {
      if (this.moneyPaid < 150000) {
        this.$message.error(`${this.$t("wap.text123")} 150.000đ.`);
        return;
      }
      const body = {
        money: this.moneyPaid,
        data_provider: { amount: this.moneyPaid },
        provider: "point_new",
        type: "bank"
      };
      this.loadingData = true;
      GlobalAPI.create_request_for_wap_point(body)
        .then(res => {
          const { error_code, data, error_msg } = res;
          if (error_code !== 0) {
            this.$message.error(error_msg);
          } else {
            this.transferData = {
              ...data.bank
            };
            console.log("error_code____________________", res);
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        Message({
          message: this.$t("wap.text127"),
          type: "success",
          duration: 3 * 1000
        });
      });
    }
  },
  computed: {}
};
</script>
<style scoped>
.top-spacing {
  padding-top: 80px;
}
.transfer-container {
  padding: 15px;
}
.text-center {
  text-align: center;
}
.md-toolbar {
  top: 0;
}
.qr-img {
  width: 100%;
  height: auto;
  text-align: center;
}
.qr-img > img {
  width: 179px;
  height: 179px;
  margin-bottom: 10px;
}

.info-transfer-item {
  width: 100%;
  margin: 12px 0px;
  background-color: #f4f4f4;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
}

.account-info label {
  display: block;
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  margin-bottom: 5px;
}

.account-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px;
}

.account-info span {
  font-weight: 600;
  font-size: 14px;
  color: #090710;
}

.footer-note {
  margin: 10px;
}

@media (min-width: 1024px) {
  .qr-img {
    width: 500px;
    margin: 80px auto 30px;
  }
  .progress-bar {
    top: 68px;
    height: 6px;
  }
  .info-transfer {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .info-transfer-item {
    max-width: 700px;
    margin: 12px auto;
  }
}
</style>
